import { useNavigate } from 'react-router-dom';
import NewEmployeeForm from './components/NewEmployeeForm';

const NewEmployee = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/employees/list');
  };
  return (
    <div className="row py-5">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between">
              <div>
                <h3 className="">Nouvel employé </h3>
              </div>
            </div>
            <div className="py-5">
              <NewEmployeeForm onSuccess={handleSuccess} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewEmployee;
